import type { CollapsedEmployeesGroups } from "@/pages/human-resources/time-management/schedules/site-schedule/grouped-rows/collapsing/CollapsedEmployeesGroups.ts";
import type { Draft } from "immer";

export type CollapsedEmployeesGroupsAction =
  | { type: "setSectionCollapsed"; sectionId: string; collapsed: boolean }
  | { type: "setRoleCollapsed"; roleId: string; collapsed: boolean };

export function collapsedEmployeesGroupsReducer(
  draft: Draft<CollapsedEmployeesGroups>,
  action: CollapsedEmployeesGroupsAction,
): void {
  switch (action.type) {
    case "setSectionCollapsed": {
      if (action.collapsed) {
        draft.sectionsIds.add(action.sectionId);
      } else {
        draft.sectionsIds.delete(action.sectionId);
      }
      break;
    }
    case "setRoleCollapsed": {
      if (action.collapsed) {
        draft.rolesIds.add(action.roleId);
      } else {
        draft.rolesIds.delete(action.roleId);
      }
      break;
    }
  }
}
